import isPrerender from './is-prerender';

const os = (function () {
    if (isPrerender()) {
        return;
    }

    const userAgent = navigator.userAgent.toLowerCase();
    const Android = userAgent.indexOf('android') > -1;

    function iOS() {
        return (
            ['iPad Simulator', 'iPhone Simulator', 'iPod Simulator', 'iPad', 'iPhone', 'iPod'].indexOf(
                navigator.platform
            ) > -1 ||
            /iPhone|iPad|iPod/i.test(navigator.userAgent) ||
            // iPad on iOS 13 detection
            (navigator.userAgent.indexOf('Mac') > -1 && 'ontouchend' in document)
        );
    }

    function macOS() {
        return navigator.platform.toUpperCase().indexOf('MAC') > -1;
    }

    return {
        isAndroid: Android,
        isIOS: iOS(),
        isMacOS: macOS()
    };
})();

export default os;
